import SummaryDetailsComponent from './SummaryDetails';

const SummaryDetails = SummaryDetailsComponent;

export default SummaryDetails;
